import axios from 'axios';
import { API_BASE_URL } from '../../../config';

export class WellsFargoSettingsApi {
  static getSettings = (organizationId) => {
    return axios.get(
      `${API_BASE_URL}/organizations/${organizationId}/wells-fargo-settings`,
    );
  };

  static updateSettings = (organizationId, data) => {
    return axios.put(
      `${API_BASE_URL}/organizations/${organizationId}/wells-fargo-settings`,
      data,
    );
  };

  static getApiCredential = (organizationId) => {
    return axios.get(
      `${API_BASE_URL}/organizations/${organizationId}/wells-fargo-settings/api-credential`,
    );
  };

  static saveApiCredential = (organizationId, data) => {
    return axios.put(
      `${API_BASE_URL}/organizations/${organizationId}/wells-fargo-settings/api-credential`,
      data,
    );
  };

  static testApiCredential = (organizationId) => {
    return axios.post(
      `${API_BASE_URL}/organizations/${organizationId}/wells-fargo-settings/api-credential/test-authentication`,
    );
  };

  static getWebhookSubscription = (organizationId) => {
    return axios.get(
      `${API_BASE_URL}/organizations/${organizationId}/wells-fargo-settings/webhook-subscription`,
    );
  };

  static registerWebhookSubscription = (organizationId, data) => {
    return axios.post(
      `${API_BASE_URL}/organizations/${organizationId}/wells-fargo-settings/webhook-subscription`,
      data,
    );
  };

  static syncWebhookSubscription = (organizationId) => {
    return axios.post(
      `${API_BASE_URL}/organizations/${organizationId}/wells-fargo-settings/webhook-subscription/sync`,
    );
  };

  static deleteWebhookSubscription = (organizationId) => {
    return axios.delete(
      `${API_BASE_URL}/organizations/${organizationId}/wells-fargo-settings/webhook-subscription`,
    );
  };
}
